module.exports = __webpack_public_path__ + "e69be9252bfa1b74ca7c2bdf531ae46e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-2.png
// module id = 2284
// module chunks = 0